import cx from 'classnames'
import { useDevice } from 'device'
import { useEventListener } from 'hooks'
import { usePublicModules } from 'models/city'
import React, { useMemo, useState } from 'react'
import { useModuleTitle } from 'models/settings'

import { Grid } from 'components/layout'
import { Href } from 'components/navigation'
import { Carousel, Text } from 'components/dataDisplay'

import { HeaderButton } from 'components/inputs'

import useAds from './util/useAds'

import s from './AdsBlock.scss'


type AdsBlockProps = {
  className?: string
  to: string
}

const AdsBlock: React.FC<AdsBlockProps> = (props) => {
  const { className, to } = props
  const { modules, isFetching: isModulesFetching } = usePublicModules()

  const { title } = useModuleTitle('ADVERTISING')
  const { adsTotal, ads } = useAds()

  const { isMobile, isTablet } = useDevice()
  const [ width, setWidth ] = useState(typeof window !== 'undefined' ? window.innerWidth : null)

  useEventListener('resize', () => setWidth(window.innerWidth))

  const filteredAds = useMemo(() => {
    if (isTablet) {
      return ads.filter((item, index) => index < 3)
    }

    return ads
  }, [ ads, isTablet ])

  const adsNode = (
    filteredAds.map(({ title, image, to }, index) => (
      <Href key={index} to={to}>
        <div className={cx(s.adCard)}>
          <div className={cx(s.imageWrapper, 'overflow-hidden flex justify-center')}>
            <img className={cx('h-full radius-16')} src={image} alt={title + ' image'} />
          </div>
          <Text
            className={cx(s.thirdLineClamp, 'mt-16px text-center flex-none webkit-box overflow-ellipsis')}
            message={title}
            size="c16"
          />
        </div>
      </Href>
    ))
  )

  return (
    <>
      <div className={cx(className, isMobile ? null : 'flex justify-between')}>
        <div className="flex-1">
          <HeaderButton
            size={isMobile ? 'h20-24' : 'h32'}
            title={title}
            to={to}
          />
          <Text
            className={cx('mt-16px opacity-72', isMobile ? null : isTablet ? 'mw-349' : 'mw-456')}
            message={`
              Городская доска частных и коммерческих объявлений, где можно найти
              различные товары и услуги или опубликовать собственное предложение
            `}
            size="t16-24"
            color="gladiator"
          />
        </div>
        {
          Boolean(adsTotal) && (
            <div className={isMobile ? 'mt-16px' : null}>
              <Text
                message={String(adsTotal)}
                size="h32"
                color="alien"
              />
              <Text
                className="mt-4px opacity-64"
                message="Объявлений размещено"
                size="s13-r"
                color="titanic"
              />
            </div>
          )
        }
      </div>
      {
        isMobile ? (
          <Carousel
            className={cx(s.carousel, 'mt-32px')}
            slidesToShow={1}
            slidesToScroll={1}
            exactWidth={typeof window !== 'undefined'}
            itemWidth={typeof window !== 'undefined' ? width - 32 : null}
            draggable
          >
            {adsNode}
          </Carousel>
        ) : (
          <Grid className="pt-40px" gutter={isTablet ? 24 : 32} columns={isTablet ? 3 : 6}>
            {adsNode}
          </Grid>
        )
      }
    </>
  )
}

export default AdsBlock